import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib';
import { observer } from 'mobx-react-lite';

let styles = require('./CardIcon.scss');

export interface CardIconProps {
    backgroundColor: string;
    iconName: string;
    iconColor: string;
}

/**
 * This is the card Icon shown in the location card header.
 */
const CardIcon = observer(function CardIcon(props: CardIconProps) {
    const coinBackgroundStyle = {
        backgroundColor: props.backgroundColor,
    };

    const iconStyle = {
        color: props.iconColor,
    };

    return (
        <div style={coinBackgroundStyle} className={styles.cardIconContainer}>
            <Icon iconName={props.iconName} style={iconStyle} className={styles.cardIcon} />
        </div>
    );
});
export default CardIcon;
